<mat-card>
  <img
    mat-card-image
    style="width: 125px; margin: 15px"
    src="./../assets/gkb.png"
  />
  <mat-card-header>
    <mat-card-title>Welkom by Brooklyn Gemeente 👋</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <ul>
      <li>
        Lees die
        <a
          target="_blank"
          href="https://docs.google.com/document/d/1XUG7hSSymlh8aDUgogfm0FdufBY_Qo_u9yeNfCkjUBM/edit?usp=sharing"
          >instruksies hier.</a
        >
      </li>
      <li>Registrasie vind vanaf 45min tot 15min voor die diens plaas.</li>
      <li>
        Die dra van maskers is verpligtend buite en binne-in die kerk, asook
        tydens gemeentesang.
      </li>
      <li>
        Dienste word op ons
        <a
          target="_blank"
          href="https://www.youtube.com/channel/UC27xO59yo5pKdbWQ10vjVng"
          >YouTube kanaal</a
        >
        uitgesaai.
      </li>
      <li>
        Volg asseblief alle
        <a
          target="_blank"
          href="https://www.gov.za/covid-19/resources/regulations-and-guidelines-coronavirus-covid-19"
          >huidige Covid19 regulasies en riglyne.</a
        >
      </li>
    </ul>
  </mat-card-content>
  <mat-card-actions align="end">
    <button mat-raised-button *ngIf="!more" (click)="more = !more">
      Meer inligting
    </button>
  </mat-card-actions></mat-card
>
<mat-card *ngIf="more">
  <mat-card-header>
    <mat-card-title>Neem kennis van die volgende</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <p style="margin-left: 16px">
      As gevolg van die COVID-19 Beperkings in werking getree het, mag slegs 50
      lidmate, waarvan 5 daarvan predikante en ander funksionarisse is, en 10
      persone in die Moederskamer mag sit, binne die kerkgebou toegelaat
      word.<br /><br />
      Brooklyn gemeente se eredienste word steeds aanlyn via YouTube uitgesaai
      by: https://www.gkbrooklyn.org.za/preke.html<br /><br />

      Sondagoggend kan jy vanaf 08:45 arriveer en inteken. Wees asseblief teen
      09:15 by die kerk sodat jy jou sitplek kan inneem. (Die rede hiervoor is
      dat die inteken-proses 'n paar minute neem en ons nie graag die erediens
      wil onderbreek deur mense wat laat kom en dan nog eers moet inteken en
      sitplek kry nie).<br /><br />
      Daar is net een ingang na die kerkgebou en wel die oostelike ingang tussen
      die kerk en die saal. Die ander deure moet oop wees vir ventilasie, maar
      sal nie vir toegang beskikbaar wees nie. Die Konsistoriedeur is gesluit.
      Die Kerkraad moet asseblief deur die bogenoemde deur die kerk betree en
      deurstap na die konsistorie. Daar sal 2 registrasiepunte wees.<br /><br />
      Die intekenproses behels: sanitering, neem van voorkop/nek temperatuur en
      skriftelike bevestiging dat u geen Covid-simptome toon of ervaar nie. Om
      die intekenproses te bespoedig, sal jou naam en adres reeds op die lys
      verskyn, omdat jy reeds bespreek het. Bespreek asseblief 'n plek vir
      elkeen in jou gesin/groep sodat almal se name individueel op die
      intekenlys kan verskyn. Ons probeer vertragings sover moontlik vermy.<br /><br />
      Sit asseblief slegs op die aangeduide plekke in die kerkgebou. Elke tweede
      bank is beskikbaar. Mense wat saam in een huishouding bly, mag langs
      mekaar sit. Moet asseblief nie op die banke sit wat met GEEN TOEGANG
      gemerk is nie.<br /><br />
      Offergawes en deurkollektes kan elektronies gedoen word deur Snapscan, of
      kan met die uitstap na die erediens in die houers by die deure geplaas
      word.<br /><br />
      Die Moederskamer is beskikbaar vir gebruik deur ouers met babas tot 'n
      maksimum van 10 ouers. As jy die Moederskamer wil gebruik, bespreek jou
      kaartjie dan sodanig. Die agterste bank in die kerkgebou is steeds ook vir
      ouers met klein kinders gemerk en beskikbaar.<br /><br />
      Handhaaf asseblief ten alle tye 1.5m sosiale afstand.<br /><br />
      Dit is verpligtend om jou masker die heeltyd te dra vandat jy die terrein
      betree tot wanneer jy die terrein verlaat, asook wanneer daar gesing word.
      Die terrein sluit die saal en kerkgeboue in.<br /><br />

      Elke persoon wat die erediens bywoon onderneem die volgende:<br />
      - Ek verstaan dat die Gereformeerde Kerk Pretoria-Brooklyn voorkomende
      maatreëls (soos deur die Suid Afrikaanse regering daargestel) ingestel het
      om die verspreiding van die Covid-19 virus te help beperk. Ek besef egter
      dat daar altyd 'n risiko by 'n publieke byeenkoms is om die virus op te
      doen.<br />
      - Ek verstaan dat die bywoon van eredienste vrywillig gedoen word en ek
      erken dat die Gereformeerde Kerk Pretoria-Brooklyn en in besonder die
      predikante en die Kerkraad nie aanspreeklik is vir enige Covid-19
      positiewe toetsing, weens moontlike blootstelling aan Covid-19 nie en sal
      daardeur nie eis vir enige skade of verlies wat mag ontstaan uit die
      deelname aan 'n erediens nie.<br />
    </p>
  </mat-card-content>
  <mat-card-actions>
    <button style="margin-left: 16px" mat-button (click)="more = !more">
      Minder inligting
    </button>
  </mat-card-actions>
</mat-card>
<mat-card *ngFor="let event of data.events">
  <mat-card-header>
    <mat-card-title>{{ event.title }}</mat-card-title>
  </mat-card-header>
  <mat-card-content
    style="
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
    "
  >
    <p *ngIf="event.description" style="padding: 15px; font-size: 16px">
      {{ event.description }}
    </p>
    <a
      *ngIf="event.link"
      style="padding: 15px; white-space: pre-wrap; font-size: 16px"
      target="_blank"
      href="{{ event.link.url }}"
      >{{ event.link.title }}</a
    >
    <img
      *ngIf="event.imageUrl"
      style="width: 100%; max-width: 600px"
      src="{{ event.imageUrl }}"
    />
    <hr />
  </mat-card-content>
</mat-card>
<mat-card>
  <mat-card-header>
    <mat-card-title>Digitale gesondheidsverklaring 👇</mat-card-title>
    <mat-card-subtitle
      >Jy kan jou gesondheidsverklaring vir 'n bespreking slegs 2 ure voor die
      diens aflê. Die verklarings sal hier verskyn 2 ure voor die diens
      begin.</mat-card-subtitle
    >
  </mat-card-header>
  <mat-nav-list>
    <mat-list-item
      *ngFor="let booking of data.myBookingsWithScreeningOpen"
      (click)="data.screen(booking)"
    >
      <a matLine
        >{{ booking.name }} -
        {{ booking.serviceTime | date: "d MMMM HH:mm" }}
        <mat-icon *ngIf="!booking.healthScreening">edit</mat-icon></a
      >
      <button mat-button color="primary">
        <mat-icon *ngIf="booking.healthScreening">check</mat-icon>
      </button>
    </mat-list-item>
  </mat-nav-list>
</mat-card>
<mat-card *ngFor="let service of data.services">
  <mat-card-header>
    <mat-card-title
      >{{ service.date | date: "d MMMM HH:mm" }} ({{
        service.description
      }})</mat-card-title
    >
  </mat-card-header>
  <mat-nav-list *ngIf="data.myBookingsDictionaryLoaded">
    <mat-list-item *ngFor="let venue of service.venues">
      <a matLine>{{ venue.description }}</a>
      <a matLine *ngIf="venue.max - venue.taken > 1"
        >{{ venue.max - venue.taken }} plekke beskikbaar</a
      >
      <a matLine *ngIf="venue.max - venue.taken === 1"
        >{{ venue.max - venue.taken }} plek beskikbaar</a
      >
      <a matLine *ngIf="venue.max - venue.taken <= 0">Geen plek beskikbaar</a>
      <a matLine>
        <span
          *ngIf="data.myBookingsDictionary[service.id][venue.description] > 0"
          >Jy het
          {{ data.myBookingsDictionary[service.id][venue.description] }}
          bespreking(s) ✅</span
        >
      </a>
      <button
        *ngIf="data.myBookingsDictionary[service.id][venue.description] === 0"
        mat-raised-button
        color="primary"
        [disabled]="!service.canBook"
        (click)="book(service, venue)"
      >
        Bespreek
      </button>
      <button
        *ngIf="data.myBookingsDictionary[service.id][venue.description] > 0"
        mat-raised-button
        color="primary"
        [disabled]="!service.canBook"
        (click)="book(service, venue)"
      >
        <mat-icon>edit</mat-icon>
      </button>
    </mat-list-item>
  </mat-nav-list>
  <mat-card-actions>
    <button mat-button (click)="viewBookings(service)">Besprekings</button>
  </mat-card-actions>
</mat-card>

<div class="footer">Gereformeerde Kerk Brooklyn</div>
